import React, { lazy, Suspense, memo } from "react";
import LoadingSpinner from "../../components/ui/feedback/LoadingSpinner";

const Dashboard = lazy(() => import("../../pages/Dashboard"));
const Courses = lazy(() => import("../../pages/Courses"));
const Bookings = lazy(() => import("../../pages/Bookings"));
const Newsletters = lazy(() => import("../../pages/Newsletters"));
const EditProfile = lazy(() => import("../../pages/EditProfile"));
const Administration = lazy(() => import("../../pages/Administration"));

interface MainContentAreaProps {
  activeComponent: string;
  setActiveComponent: (component: string) => void;
  activeAdministrationComponent: string;
}

const MainContentArea: React.FC<MainContentAreaProps> = ({
  activeComponent,
  setActiveComponent,
  activeAdministrationComponent,
}) => {
  const renderActiveComponent = () => {
    switch (activeComponent) {
      case "dashboard":
        return <Dashboard />;
      case "courses":
        return <Courses setActiveComponent={setActiveComponent} />;
      case "newsletters":
        return <Newsletters />;
      case "bookings":
        return <Bookings />;
      case "profile":
        return <EditProfile />;
      case "administration":
        return (
          <Administration activeComponent={activeAdministrationComponent} />
        );
      default:
        return null;
    }
  };

  return (
    <main className="max-h-full max-w-full overflow-x-hidden h-full w-full">
      <Suspense fallback={<LoadingSpinner />}>
        {renderActiveComponent()}
      </Suspense>
    </main>
  );
};

export default memo(MainContentArea);
